import { useQuery } from "@tanstack/react-query";
import { fetchRepairPolicy } from "../api/fetchRepairPolicy";

export const useRepairPolicy = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["repairPolicyMaster"],
    queryFn: fetchRepairPolicy,
  });

  return { data: data?.result || [], error, isLoading, refetch };
};
